import {useSelector} from "react-redux";
import {State} from "@App/state";
import {useQuery} from "@apollo/client";
import {GET_VEHICLE_EQUIPMENTS} from "@App/graphql/queries/getVehicleEquipments";
import {useDates} from "@App/hooks/useDates";

export const useVehicleEquipments = () => {

    const {toIsoString} = useDates()

    const brand = useSelector((state: State) => state.orders.brand)
    const generation = useSelector((state: State) => state.orders.generation)
    const motorization = useSelector((state: State) => state.orders.motorization)
    const gearbox = useSelector((state: State) => state.orders.gearbox)
    const initialRegistrationDate = useSelector((state: State) => state.orders.initialRegistrationDate)

    const {loading, data, error} = useQuery(GET_VEHICLE_EQUIPMENTS, {
        variables: {
            ...brand && {brandId: brand.id, brandSlug: brand.slug},
            ...generation && {generationId: generation.id, generationSlug: generation.slug},
            ...motorization && {motorizationId: motorization.id, motorizationSlug: motorization.slug},
            ...gearbox && {gearboxId: gearbox.id},
            ...initialRegistrationDate && {initialRegistrationDate: toIsoString(initialRegistrationDate)},
            includeGenerations: true,
            includeMotorizations: true
        }
    })

    return {
        loading: loading,
        error: error,
        equipments: data ? data.brands[0].generations[0].motorizations[0].equipment : null,
    }
}


